import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Button,
  Modal,
  Form,
  Col,
  Table,
  Spin,
  Select,
  Divider,
  Tag,
} from "antd";

import { CheckCircleOutlined } from "@ant-design/icons";

// PROJECT IMPORTS
import MainLayout from "../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../components/layouts/enhancement/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
// import DownloadTableButtons from "../../../components/DownloadTableButtons";
import { rightAction } from "../../../redux/actions";
import { handleFlgStatus } from "../../../components/facilities/AccountFacility";
import { apiConfig, labelConfig, staticConfig } from "../reports.config";
import DownloadTableButtons from "../../../components/layouts/enhancement/DownloadTableButtons";

const { Text, Title } = Typography;

const columns = [
  {
    title: "Report Name",
    dataIndex: "name",
  },
  {
    title: "Report Type",
    dataIndex: "type",
  },
  // {
  //   title: "Report SubType",
  //   dataIndex: "subtype",
  // },
  {
    title: "Report Category",
    dataIndex: "category",
  },
  {
    title: "Core Report",
    dataIndex: "coreReport",
  },
  {
    title: "User Report",
    dataIndex: "useReport",
  },
];

const ManageCustomReports = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("25");
  const [reportList, setReportsList] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [officesData, setOfficesData] = useState([]);
  const [officeId, setOfficeId] = useState(0);

  useEffect(() => {
    getLoanReportsList();
  }, []);

  const getLoanReportsList = () => {
    const params = {
      R_reportCategory: "Client",
      genericResultSet: false,
      parameterType: true,
    };

    const url = `${apiConfig.Reports}`;

    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        let tempLoanReportsList = [];
        // const filteredArray = objList.filter((item) => item.parameter_name === "OfficeIdSelectOne");

        console.log(objList);

        objList
          .filter(
            (item) =>
              item.reportType.toLowerCase() === "table" ||
              item.reportType.toLowerCase() === "pentaho"
          )
          .forEach((element) => {
            // if (element.report_type?.toLowerCase() !== "sms") {
            tempLoanReportsList.push({
              key: element?.id,
              id: element?.id,
              name: element?.reportName ? element?.reportName : "-",
              type: element?.reportType ? element?.reportType : "-",
              subtype: element?.reportSubType ? element?.reportSubType : "-",
              category: element?.reportCategory ? element?.reportCategory : "-",
              coreReport: element?.coreReport ? "true" : "false",
              useReport: element?.useReport ? "true" : "false",
            });
            // }
          });

        setReportsList(tempLoanReportsList);
        setOriginalList(tempLoanReportsList);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  //DECLARED METHODS
  const onSelectItemAction = (selectedRowKeys, objParam) => {
    dispatch({ type: cnt.CLEAR_RIGHT_BTN });
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    if (selectedRowKeys.length === 1) {
      [cnt.RIGHT_ADD_BTN, cnt.RIGHT_RUN_BTN, cnt.RIGHT_EDIT_BTN, cnt.RIGHT_DETAIL_BTN].map(
        (item) => {
          dispatch({ type: item });
        }
      );
    } else {
      [cnt.RIGHT_ADD_BTN].map((item) => {
        dispatch({ type: item });
      });
    }
  };

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;

    if (!searchKey) {
      setReportsList(originalList);
      return;
    }
    const filterBySearch = originalList.filter((item) =>
      item?.name?.toLowerCase().includes(searchKey?.toLowerCase())
    );
    setReportsList(filterBySearch);
  }
  function selectTableCount(value) {
    setTableCount(value);
  }
  function handleOnRun() {
    const { runBtn } = rightBtn;
    if (runBtn.toLowerCase() === "primary") {
      navigate("/run-customer-reports", { state: { id: selectedRow.id, name: selectedRow.name } });
    } else {
      console.log("Could not open the link");
    }
  }
  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/create-custom-report", {
        state: selectedRow,
      });
    } else {
      console.log("No valid row selected or invalid add button.");
    }
  }
  function handleOnEdit() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/edit-custom-report", {
        state: selectedRow,
      });
    } else {
      console.log("No valid row selected or invalid add button.");
    }
  }
  function handleOnView() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/view-custom-report", {
        state: selectedRow,
      });
    } else {
      console.log("No valid row selected or invalid add button.");
    }
  }

  useEffect(() => {
    BOM.HasPermission("CREATE_REPORT") && rightAction(cnt.RIGHT_ADD_BTN);
  }, []);

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onRun={handleOnRun}
      onAdd={handleOnCreate}
      onView={handleOnView}
      onEdit={handleOnEdit}
      pageItems={staticConfig.manageCustomReportsBreadcrumbItems}
    >
      <TopContent
        pageTitle={labelConfig.customReports}
        createPageTitle={`${labelConfig.reports} Listing`}
      />

      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
          marginTop: 12,
        }}
      >
        {/* RENDER TABLE LIST HERE*/}
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Name"
                style={{
                  width: 400,
                }}
                allowClear
              />
            </div>

            <DownloadTableButtons
              downloadData={reportList}
              columns={columns}
              fileName={labelConfig.customReports}
            />
          </Row>
          <div className="interbankplacement-table">
            <Table
              className="bond-table"
              rowSelection={{
                type: "checkbox",
                onChange: onSelectItemAction,
                hideSelectAll: true,
              }}
              columns={columns}
              dataSource={reportList}
              bordered
              pagination={{
                position: "bottomCentre",
                pageSize: tableCount,
                showSizeChanger: false,
              }}
            />
          </div>
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(ManageCustomReports);
